import { BrowserStorage } from '@utils/BrowserStorage';

export class CountShowingAdultBannerService {
  private readonly key = 'countShowingAdultBanner';

  private browserStorage = new BrowserStorage(this.key);

  public get count(): number {
    return this.browserStorage.getObject(this.key);
  }

  public initializeOrUpdate(count: number) {
    this.browserStorage.setObject(this.key, count);
  }

  public clear() {
    this.browserStorage.clear();
  }
}
